import { Button } from "@/components/ui/FormControls";
import type { Issue, IssueLevel } from "@h2lca/core";
import { STEPS, useWorkshop } from "@/store/workshop";
import { ISSUE_LEVEL_LABEL, stepOfIssue } from "./helpers";

const NOTE_CLASS: Record<IssueLevel, string> = { error: "note note-danger", warning: "note note-warn", info: "text-footnote text-ink-subtle" };

/** 검증 메시지 한 줄 , 수준별 색, 필요하면 해당 단계로 가는 버튼 */
export function IssueLine({ issue, link = true }: { issue: Issue; link?: boolean }) {
  const setStep = useWorkshop((s) => s.setStep);
  const select = useWorkshop((s) => s.select);
  const step = stepOfIssue(issue);
  const target = step ? STEPS.find((s) => s.id === step) : undefined;
  return (
    <div className={`${NOTE_CLASS[issue.level]} flex items-start justify-between gap-item text-footnote`}>
      <span>{issue.message}</span>
      {link && target && (
        <Button
          type="button"
          size="compact"
          onClick={() => {
            if (issue.equipmentId) select(issue.equipmentId);
            setStep(target.id);
          }}
        >
          {target.short} 단계로
        </Button>
      )}
    </div>
  );
}

/** 수준별로 묶은 검증 메시지 목록 */
export function IssueList({ issues, link = true }: { issues: Issue[]; link?: boolean }) {
  if (issues.length === 0) return <p className="note note-ok text-footnote">검증 메시지가 없습니다.</p>;
  const levels: IssueLevel[] = ["error", "warning", "info"];
  return (
    <div className="flex flex-col gap-content">
      {levels.map((level) => {
        const list = issues.filter((i) => i.level === level);
        if (list.length === 0) return null;
        return (
          <div key={level} className="flex flex-col gap-label">
            <p className="text-caption font-semibold text-ink">
              {ISSUE_LEVEL_LABEL[level]} <span className="font-mono text-ink-muted">{list.length}</span>
            </p>
            {list.map((issue, i) => (
              <IssueLine key={`${issue.code}-${issue.equipmentId ?? ""}-${issue.inputId ?? ""}-${i}`} issue={issue} link={link} />
            ))}
          </div>
        );
      })}
    </div>
  );
}
